export default "/images/folder-minus.svg?dcd0d0f5c98a46e74f2ca50607c6d674";